module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "otherbooksby"
    }
  }, [_c('h2', {
    staticClass: "left"
  }, [_vm._v("Books by Margaret Moore")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Harlequin Historicals"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("*")]), _vm._v(" "), _c('i', [_vm._v("A Warrior’s Heart")]), _vm._v(" #118")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("China Blossom")]), _vm._v(" #149")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("*")]), _vm._v(" "), _c('i', [_vm._v("A Warrior’s Quest")]), _vm._v(" #175")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("†")]), _vm._v(" "), _c('i', [_vm._v("The Viking")]), _vm._v(" #200")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("*")]), _vm._v(" "), _c('i', [_vm._v("A Warrior’s Way")]), _vm._v(" #224")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Vows")]), _vm._v(" #248")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("†")]), _vm._v(" "), _c('i', [_vm._v("The Saxon")]), _vm._v(" #268")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("*")]), _vm._v(" "), _c('i', [_vm._v("The Welshman’s Way")]), _vm._v(" #295")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("*")]), _vm._v(" "), _c('i', [_vm._v("The Norman’s Heart")]), _vm._v(" #311")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("*")]), _vm._v(" "), _c('i', [_vm._v("The Baron’s Quest")]), _vm._v(" #328")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("‡")]), _vm._v(" "), _c('i', [_vm._v("The Wastrel")]), _vm._v(" #344")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("‡")]), _vm._v(" "), _c('i', [_vm._v("The Dark Duke")]), _vm._v(" #364")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("‡")]), _vm._v(" "), _c('i', [_vm._v("The Rogue’s Return")]), _vm._v(" #376")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("∇")]), _vm._v(" "), _c('i', [_vm._v("The Knights of Christmas")]), _vm._v(" #387")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("*")]), _vm._v(" "), _c('i', [_vm._v("A Warrior’s Bride")]), _vm._v(" #395")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("*")]), _vm._v(" "), _c('i', [_vm._v("A Warrior’s Honor")]), _vm._v(" #420")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("*")]), _vm._v(" "), _c('i', [_vm._v("A Warrior’s Passion")]), _vm._v(" #440"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("*")]), _vm._v(" Warrior Series")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("†")]), _vm._v(" The Viking Series")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("∇")]), _vm._v(" In-line Christmas Collection")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('sup', [_vm._v("‡")]), _vm._v(" Most Unsuitable…")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Harlequin Books"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Mistletoe Marriages")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Christmas in the Valley”")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0efde5fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006-otherbooksby.vue
// module id = 69
// module chunks = 0